import * as Teleport from '../utilities/Teleport';
import * as ActionModifiers from '../ActionModifiers';

function App(props) {

  var itemEdited = props.itemEdited;
  var item = props.item;
  var currentList = props.currentList;
  var objPath = props.objPath;
  var changeTab = props.changeTab;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var setItemEdited = props.setItemEdited;
  var screenRefs = props.screenRefs;
  var leftColRefs = props.leftColRefs;
  var flashHighlight = props.flashHighlight;
  var setFlashHighlight = props.setFlashHighlight;
  var centerZoom = props.centerZoom;
  var fakeInternalVariables = props.fakeInternalVariables;
  var chains = props.chains;

  var itemType;
  if (itemEdited.t === 'alert'){
    itemType = 'alert';
  }else if (itemEdited.t === 'item'){
    itemType = item.t;
  }
  var p = ActionModifiers.actionMods(currentList, objPath, itemType, chains, changeTab);
  function onClickTeleporter(i){
    return function(e){
      Teleport.goToLocation(i.screenPath, i.path, null, changeTab, setIsShowingSomeDropDown, setItemEdited, screenRefs, leftColRefs, flashHighlight, setFlashHighlight, 'blue', currentList, centerZoom, fakeInternalVariables);
    }
  }
  var mods = p.map((aP, index)=>{
    return <div className='highlightBox' onClick={onClickTeleporter(aP)} key={index} style={{marginBottom:'5px'}}><p className='lead mb-0'>{aP.name}, {aP.n}.</p></div>
  })
  if (mods.length === 0){
    mods = <p className='lead mb-0'>No modifications. This means that this element is not modified via actions such as button clicks and changes to inputs.</p>
//
  }
  return (<td>{mods}</td>)
}
//
export default App;
